export const OTPHelpers = {
  placeholder: '_ _ _ _ _ _',
  translationTag: 'auth.otp.codeLabel' as const,
  autoComplete: 'off',
  normalize: (value: string) => value.replaceAll(/\D+/gi, '').slice(0, 6),
};
